import { FC } from 'react';
import { VStack } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';

import OBList from '../../../OBList';

interface ChecklistProps {
  checks: string[];
  description?: string;
  normalFont?: boolean;
}

/**
 * A checklist to display alongside the upload zone.
 */
const Checklist: FC<ChecklistProps> = ({ checks, description, normalFont }) => (
  <VStack align="stretch" marginTop="space-32">
    {description ? (
      <Text marginBottom="space-24" variant="primary">
        {description}
      </Text>
    ) : null}

    <OBList>
      {checks.map((check) => (
        <OBList.Item alignItems="center" key={check}>
          <SunshineIcon color="grey.800" name="tick" size="icon-16" />

          <Text
            fontWeight={normalFont ? 'weight-400' : 'weight-500'}
            variant="primary"
          >
            {check}
          </Text>
        </OBList.Item>
      ))}
    </OBList>
  </VStack>
);

export default Checklist;
